import type { ValueOf } from '../types';

export const STATUS_CODE = {
  OK: 200,
  NOT_DUPLICATED: 204,
  SEE_OTHER: 303,
  SEE_OTHER_DOMAIN: 3031,
  SEE_OTHER_PROJECT: 3032,
  TEMPORARY_REDIRECT: 307,
  PERMANENT_REDIRECT: 308,
  BAD_REQUEST: 400,
  BAD_REQUEST_PROJECT: 4002,
  BAD_REQUEST_REGION: 4003,
  UNAUTHORIZED: 401,
  UNAUTHORIZED_EXPIRED_TOKEN: 4011,
  PAYMENT_REQUIRED: 402,
  FORBIDDEN: 403,
  FORBIDDEN_DOMAIN: 4031,
  FORBIDDEN_PROJECT: 4032,
  FORBIDDEN_REGION: 4033, // 리전에 제공되지 않는 서비스
  FORBIDDEN_REGION_SUB: 4034, // 리전에 제공되지 않는 서비스의 하위 메뉴
  NOT_FOUND: 404,
  NOT_FOUND_SERVICE: 4041,
  NOT_FOUND_ROUTE: 4042,
  NOT_ACCEPTABLE: 406,
  CONFLICT: 409,
  REQUEST_ENTITY_TOO_LARGE: 413,
  UNSUPPORTED_MEDIA_TYPE: 415,
  UNPROCESSABLE_ENTITY: 422,
  LOCKED: 423,
  TOO_MANY_REQUESTS: 429,
  SESSION_TIMEOUT: 440,
  INTERNAL_SERVER_ERROR: 500,
  INTERNAL_SERVER_ERROR_WITH_GNB: 5001,
  INTERNAL_SERVER_ERROR_IN_SERVICE: 5002,
  SERVICE_UNAVAILABLE: 503,
  CLIENT_CLOSE_REQUEST: 499,
} as const;

export type StatusCode = ValueOf<typeof STATUS_CODE>;

/**
 * 쿼리 재시도 시 제외할 상태 코드 목록 (Default : 전역 기본값)
 */
export const DEFAULT_NON_RETRY_STATUS_CODES: StatusCode[] = [
  STATUS_CODE.UNAUTHORIZED,
  STATUS_CODE.FORBIDDEN,
  STATUS_CODE.NOT_FOUND,
];

/**
 * 상세 게이팅 API가 이 상태 코드로 실패하면 목록으로 복귀합니다.
 * 리소스가 없거나(404) 접근할 수 없어(403) 재시도로 회복되지 않는 응답입니다.
 * 401은 전역 Error401Modal이 소유하므로 포함하지 않습니다.
 */
export const DETAIL_REDIRECT_STATUS_CODES: StatusCode[] = [
  STATUS_CODE.FORBIDDEN,
  STATUS_CODE.NOT_FOUND,
];
